// extracted by mini-css-extract-plugin
export default {"formGroupItem":"form-group-item_formGroupItem__2jlpZ","stacked":"form-group-item_stacked__LcSxw","typeCustodian":"form-group-item_typeCustodian__QvYEF"};